import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c29ab6e4")

_pushScopeId("data-v-c29ab6e4")
const _hoisted_1 = { class: "jdl-wrap" }
const _hoisted_2 = { class: "jdl-title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "作业查看", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "—", -1)
const _hoisted_5 = { class: "ctr-group" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_7 = {
  class: "flex flex-row justify-between",
  style: {"padding-bottom":"14px"}
}
const _hoisted_8 = {
  key: 0,
  class: "ca-release ml16"
}
const _hoisted_9 = {
  key: 0,
  class: "ml16"
}
const _hoisted_10 = {
  key: 1,
  class: "ca-release"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, null, {
      title: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("span", null, _toDisplayString(_ctx.jobDetailList.homeWorkInfo.jobName), 1)
        ])
      ]),
      controllers: _withId(() => [
        _createVNode(_component_SvgIcon, {
          class: "fs22 pointer",
          icon: "back",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jobDetailListController.gotoJobView()))
        })
      ]),
      content: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_a_table, {
            class: "mb14 teacher-table",
            columns: _ctx.jobDetailList.columns.value,
            "data-source": _ctx.jobDetailList.data.list,
            pagination: false,
            loading: _ctx.jobDetailList.quering.value || _ctx.jobDetailList.deleting.value,
            "row-key": "id"
          }, {
            index: _withId(({record,index}) => [
              _createVNode("span", null, _toDisplayString(index+1), 1)
            ]),
            operation: _withId(({record}) => [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_a_button, {
                  type: 'link',
                  onClick: ($event: any) => (_ctx.jobDetailListController.handleViewClick(record)),
                  disabled: record.finishStatus!=="已完成" || record.ranking === -1
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"])
              ])
            ]),
            _: 1
          }, 8, ["columns", "data-source", "loading"]),
          _createVNode("div", _hoisted_7, [
            (_ctx.jobDetailList.homeWorkInfo.assignmentModel)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jobDetailListController.handleRelease())),
                    loading: _ctx.jobDetailList.loadings.release,
                    disabled: _ctx.jobDetailList.homeWorkInfo.gradeStatus === 1 || _ctx.jobDetailList.homeWorkInfo.assignStatus !== 2
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.jobDetailList.homeWorkInfo.gradeStatus === 0 ? "发布成绩" : "已发布"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]),
                  (_ctx.jobDetailList.homeWorkInfo.gradeStatus === 0)
                    ? (_openBlock(), _createBlock("span", _hoisted_9, "只有作业结束时才可以发布成绩，发布后将不能进行成绩修改"))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10)),
            _createVNode(_component_a_pagination, {
              class: "ca-page",
              "show-quick-jumper": "",
              total: _ctx.jobDetailList.data.pagination.totalRecords,
              "page-size": _ctx.jobDetailList.data.pagination.pageSize,
              current: _ctx.jobDetailList.data.pagination.pageNo,
              "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (_ctx.jobDetailList.data.pagination.pageNo = $event)),
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jobDetailListController.handlePageChange($event)))
            }, null, 8, ["total", "page-size", "current"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
})